import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Customize = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M4 8C4 5.79086 5.79086 4 8 4H13C15.2091 4 17 5.79086 17 8V13C17 15.2091 15.2091 17 13 17H8C5.79086 17 4 15.2091 4 13V8ZM8 6C6.89543 6 6 6.89543 6 8V13C6 14.1046 6.89543 15 8 15H13C14.1046 15 15 14.1046 15 13V8C15 6.89543 14.1046 6 13 6H8ZM23 8C23 5.79086 24.7909 4 27 4H32C34.2091 4 36 5.79086 36 8V13C36 15.2091 34.2091 17 32 17H27C24.7909 17 23 15.2091 23 13V8ZM27 6C25.8954 6 25 6.89543 25 8V13C25 14.1046 25.8954 15 27 15H32C33.1046 15 34 14.1046 34 13V8C34 6.89543 33.1046 6 32 6H27ZM29.5 23C30.0523 23 30.5 23.4477 30.5 24V28.5L35 28.5C35.5523 28.5 36 28.9477 36 29.5C36 30.0523 35.5523 30.5 35 30.5L30.5 30.5V35C30.5 35.5523 30.0523 36 29.5 36C28.9477 36 28.5 35.5523 28.5 35V30.5L24 30.5C23.4477 30.5 23 30.0523 23 29.5C23 28.9477 23.4477 28.5 24 28.5L28.5 28.5V24C28.5 23.4477 28.9477 23 29.5 23ZM4 27C4 24.7909 5.79086 23 8 23H13C15.2091 23 17 24.7909 17 27V32C17 34.2091 15.2091 36 13 36H8C5.79086 36 4 34.2091 4 32V27ZM8 25C6.89543 25 6 25.8954 6 27V32C6 33.1046 6.89543 34 8 34H13C14.1046 34 15 33.1046 15 32V27C15 25.8954 14.1046 25 13 25H8Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Customize;
